import actionsTypes from "./actions.types";

export default {
  [actionsTypes.FETCH_ACTIONS_SUCCESS](state, payload) {
    state.type = actionsTypes.FETCH_ACTIONS_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [actionsTypes.FETCH_ACTIONS_FAILED](state, payload) {
    state.type = actionsTypes.FETCH_ACTIONS_FAILED;
    state.error = payload.error;
  },
  [actionsTypes.FETCH_ACTIONS_REQUEST](state) {
    state.type = actionsTypes.FETCH_ACTIONS_REQUEST;
    state.error = "";
  },

  [actionsTypes.ADD_ACTION_SUCCESS](state, payload) {
    state.type = actionsTypes.ADD_ACTION_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [actionsTypes.ADD_ACTION_FAILED](state, payload) {
    state.type = actionsTypes.ADD_ACTION_FAILED;
    state.error = payload.error;
  },
  [actionsTypes.ADD_ACTION_REQUEST](state) {
    state.type = actionsTypes.ADD_ACTION_REQUEST;
    state.error = "";
  },

  [actionsTypes.UPDATE_ACTION_SUCCESS](state, payload) {
    state.type = actionsTypes.UPDATE_ACTION_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [actionsTypes.UPDATE_ACTION_FAILED](state, payload) {
    state.type = actionsTypes.UPDATE_ACTION_FAILED;
    state.error = payload.error;
  },
  [actionsTypes.UPDATE_ACTION_REQUEST](state) {
    state.type = actionsTypes.UPDATE_ACTION_REQUEST;
    state.error = "";
  },

  [actionsTypes.DELETE_ACTION_SUCCESS](state) {
    state.type = actionsTypes.DELETE_ACTION_SUCCESS;
  },
  [actionsTypes.DELETE_ACTION_FAILED](state, payload) {
    state.type = actionsTypes.DELETE_ACTION_FAILED;
    state.error = payload.error;
  },
  [actionsTypes.DELETE_ACTION_REQUEST](state) {
    state.type = actionsTypes.DELETE_ACTION_REQUEST;
    state.error = "";
  }
};
